import { render, staticRenderFns } from "./P01PersonalInformation.vue?vue&type=template&id=4f5ee4a4&lang=pug"
import script from "./P01PersonalInformation.vue?vue&type=script&lang=js"
export * from "./P01PersonalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports